// removed by extract-text-webpack-plugin
module.exports = {"fadeEdges":"_1O2PyaC2juUKvZJf8RoJm-","padding":"_1k9vFgImsVQXZuM46KSm3d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimezoneSelect/index.css
// module id = 171
// module chunks = 0